// extracted by mini-css-extract-plugin
export default {"container":"SearchWizard_container__TPy3Z","card":"SearchWizard_card__m9BTy","icon":"SearchWizard_icon__2cr3H","text":"SearchWizard_text__Q94BQ"};